import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const clientCodeAtom = atomWithStorage('pitch_client_code', '');
export const tenantIdAtom = atomWithStorage('pitch_tenant_id', '');
export const switchClientAtom = atom(false);
export const mediaBrowserAtom = atom(false);
export const createBriefAtom = atom(false);
export const clientLogoAtom = atom(null);
